import { useState } from "react";
import { Box, Text, VStack, Spacer, HStack, useMediaQuery } from "native-base";
import ContainerCards from "../../components/cards";
import { COLORS } from "../../utils/colors";
import Reviews from "../../containers/review";
import DividerLine from "../../components/divider";
import Comments from "../../containers/comments";
import CustomButton from "../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import Svg from "react-native-svg";
import {
  accordionExpandCloseSVG,
  accordionExpandOpenSVG,
} from "../../utils/svg";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";

const ReviewContainer = ({
  review,
  totalReviewCount,
  totalRated,
  totalReview,
  ind,
}) => {
  const [visibleItems, setVisibleItems] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const showMore = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 5);
  };

  return (
    <ContainerCards
      width="inherit"
      height="auto"
      background={COLORS.WHITE_COLOR}
    >
      <Box w="100%" pb={3} pt={6}>
        <Box px={6} mb={4}>
          <HStack justifyContent="space-between">
            <Text
              fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
            >
              {review.name}
            </Text>
            <Box
              onPress={toggleAccordion}
              flexDirection="row"
              alignItems="center"
              style={{ cursor: "pointer" }}
            >
              <Svg
                curs
                width="24"
                height="24"
                viewBox="0 0 24 24"
                onClick={toggleAccordion}
              >
                {isOpen ? accordionExpandOpenSVG : accordionExpandCloseSVG}
              </Svg>
            </Box>
          </HStack>
          {isOpen && (
            <>
              <Spacer size={5} />
              <Reviews
                overallAverage={totalReviewCount}
                overallRating={totalRated}
                totalReview={totalReview}
              />
            </>
          )}
        </Box>
        {isOpen && <DividerLine mb direction="horizontal" />}
        {isOpen && (
          <VStack
            space={4}
            mt={5}
            pl={6}
            pb={5}
            pr={MobileWindow && 6}
            w={MobileWindow ? "100%" : "90%"}
          >
            {review.review?.slice(0, visibleItems).map((item, index) => (
              <ContainerCards
                boxShadow=""
                background={COLORS.ATTACHMENT_FILES_COLOR}
                width="100%"
                height="auto"
                key={index}
              >
                <Comments
                  stars={item.rating}
                  comments={item.review && `"${item.review}"`}
                  reviewPayload={item.reviewPayload}
                  showDeleteIcon={false}
                />
              </ContainerCards>
            ))}
            {visibleItems < review.review.length && (
              <CustomButton
                isOutline
                text="Read More"
                textColor={COLORS.BLACK_COLOR}
                bgColor={COLORS.BLACK_COLOR}
                borderRadius="50px"
                width="fit-content"
                py={3}
                onPress={showMore}
              />
            )}
          </VStack>
        )}
      </Box>
    </ContainerCards>
  );
};

export default ReviewContainer;
